export default {
  stock_download_title: '证券交易平台下载',
  futures_download_title: '期货交易平台下载',
  fx_Pro_download_title: 'Eddid FX Pro下载',
  fx_MT5_download_title: 'MetaTrader5(MT5)下载',
  stock_iOS: 'iOS',
  stock_Android: 'Android',
  stock_Microsoft: 'Microsoft',
  stock_web: '网页版',
  stock_security_code_ios: '保安编码(IOS)',
  stock_security_code_android: '保安编码(Android)',
  fx_pro_for_iPhone: 'iOS',
  fx_pro_for_Android: 'Android',
  fx_pro_for_Windows_html: 'Windows (html)',
  fx_pro_for_Windows_java: 'Windows (java)',
  fx_pro_for_java: 'Java',
  fx_mt5_for_iPhone: 'iOS',
  fx_mt5_for_Android: 'Android',
  fx_mt5_for_Windows: 'Windows',
  fx_mt5_eddid_ios: 'EDDID账户双重认证软件（IOS）',
  fx_mt5_eddid_android: 'EDDID账户双重认证软件（Android）',
  futures_download: '交易平台下载',
  futures_use_download: '使用手册下载',
  eddid_pro: 'Eddid Pro',
  eddid_lite: 'Eddid Lite'
}
